import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import ImageWrapper from '../../../../new-components/ImageWrapper';

const CoverSection = ({
  coverImagePath,
  breadcrumbs
}: {
  coverImagePath: string;
  breadcrumbs: React.ReactElement;
}) => {
  const { t } = useTranslation('entity');

  return (
    <Container>
      <div className="breadcrumbs-container">
        <div className="container-fluid">{breadcrumbs}</div>
      </div>
      <ImageWrapper
        src={coverImagePath}
        alt="Compound cover image"
        fill
        className="cover-image"
        style={{
          objectFit: 'cover',
          zIndex: -1,
          position: 'absolute',
          border: 'none'
        }}
        loading="eager"
        imageSize="default"
      />
      <div className="cover-overlay"></div>
    </Container>
  );
};

const Container = styled.div`
  width: 100vw;
  height: 70vh;
  position: relative;
  z-index: 99;
  .breadcrumbs-container {
    width: 100vw;
    background: rgba(255, 255, 255, 0.6);
    display: flex;
    align-items: center;
    height: 46px;

    #breadcrumbs {
      padding: 0;
    }
  }
  .cover-overlay {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 50%;
    background: linear-gradient(
      0deg,
      #f9fafb 10.63%,
      rgba(255, 255, 255, 0) 96.21%
    );

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      backdrop-filter: blur(12px);
      height: 100px;
      width: 100vw;
    }
  }
`;

export default CoverSection;
